//引入store中app模块的mapKey
import store from "@/store";


// 百度地图配置 gwHUx2BXdkIw9nbsMA0GUAbVY55kYEVx
const BAIDU_MAP_CONFIG = {
    API_KEY: AppConfig.BAIDU_MAP_KEY || "", // 从配置文件读取
    LIBRARIES: [
        "https://api.map.baidu.com/library/DrawingManager/1.4/src/DrawingManager_min.js",
        "https://api.map.baidu.com/library/TextIconOverlay/1.2/src/TextIconOverlay_min.js"
    ]
};
//'AIzaSyB0ycw_zSFU5KZtQbksscehbM4Pwpyelww', // 从配置文件读取
const GOOGLE_MAP_CONFIG = {
    API_KEY: AppConfig.GOOGLE_MAP_KEY || "",
    LIBRARIES: [
        "drawing",
        "marker"
    ]
};

//高德地图配置 bed3f5da8ce2c981f100af6eca3a3e37
const A_MAP_CONFIG = {
    API_KEY: AppConfig.A_MAP_KEY || "",
    LIBRARIES: [
        "AMap.ToolBar",
        "AMap.MouseTool",
        "AMap.MarkerClusterer"
    ]
};



function MapLoader() {
    this.loadScriptAsync = function (url) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = url;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
            document.head.appendChild(script);
        });
    };
    this.loadBaiduMap = async function () {
        await this.loadScriptAsync(`https://api.map.baidu.com/api?v=3.0&ak=${BAIDU_MAP_CONFIG.API_KEY}&callback=initBaiDuMap`);
        return new Promise((resolve, reject) => {
            window.initBaiDuMap = async () => {
                try {
                    // 加载依赖库
                    for (const libUrl of BAIDU_MAP_CONFIG.LIBRARIES) {
                        await this.loadScriptAsync(libUrl);
                    }
                    resolve();
                } catch (error) {
                    reject(error);
                }
            };
        });
    };
    this.loadGoogleMap = async function () {
        if (window.google == undefined || window.google.maps == undefined) {
            await this.loadScriptAsync(`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_CONFIG.API_KEY}&libraries=${GOOGLE_MAP_CONFIG.LIBRARIES.join(',')}`);

            await this.loadScriptAsync(`https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js`);
            return new Promise((resolve, reject) => {


                resolve();


            });
        }
    };
    this.loadAMap = async function () {
        if (window.AMap == undefined) {
            await this.loadScriptAsync(`https://webapi.amap.com/maps?v=2.0&key=${A_MAP_CONFIG.API_KEY}&plugin=${A_MAP_CONFIG.LIBRARIES.join(',')}`);




            return new Promise((resolve, reject) => {
                resolve();
            });
        }
    };
}
export default MapLoader;
